import { useState } from "react";
import { NavLink, Route, Routes, useNavigate } from "react-router-dom";

export function PasswordGate(props: { setLoggedIn: (newValue: boolean) => void }) {
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [registerMessage, setRegisterMessage] = useState("");
  const [loginStatus, setLoginStatus] = useState("");
  const navigate = useNavigate();

  function login(evt: React.MouseEvent<HTMLFormElement>) {
    evt.preventDefault();
    let formData = new FormData(evt.currentTarget);
    fetch("/api/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userName: formData.get("userName"),
        userPassword: formData.get("userPassword"),
      }),
    })
      .then((res) => {
        if (res.status === 200) {
          return res.json();
        }
        return res.text().then((text) => Promise.reject(text));
      })
      .then((data) => {
        console.log(data);
        localStorage.setItem("user-name", data.username);
        localStorage.setItem("user-role", data.role);
        props.setLoggedIn(true);
      })
      .catch(async (error) => {
        await error;
        setLoginStatus(error);
      });
  }

  function register(evt: React.FormEvent<HTMLFormElement>) {
    evt.preventDefault();
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let formData = new FormData(evt.currentTarget);
    if (formData.get("userPassword") !== formData.get("userConfirmPassword")) {
      setAlertMessage("Passwords don't match");
      return;
    }
    console.log("registering with ", evt);
    fetch("/api/registerUser", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userName: formData.get("userName"),
        userPassword: formData.get("userPassword"),
        inviteCode: formData.get("inviteCode"),
        email: formData.get("userEmail"),
      }),
    })
      .then((res) => {
        if (res.status === 200) {
          setRegisterMessage("Registration successful");
          navigate("..");
          return "";
        } else {
          return res.text();
        }
      })
      .then((data: string) => {
        setAlertMessage(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  return (
    <div className="password-gate top-bar-offset">
      <Routes>
        <Route
          path="/*"
          element={
            <>
              <div>{registerMessage}</div>
              <div className="login-hello">
                Hey there! You arrived to Czech Games Online, a platform for online testing and development of upcoming
                CGE games!
                <br />
                Right now, the system is not intended for public use. To get access, you need to be invited directly by
                CGE by giving you a single-use invitation code. To get access, please, get in touch with Mucube on
                Discord.
                <br />
                If you have the 10-character-long invitation code (such as D3KB6E8ACF), you can create your account
                here: <br></br>
                <NavLink to="/register">
                  <button className={"register-login"}>Register</button>
                </NavLink>
                <br />
                If you already have created an account, you can log in:
                <form method="post" action="user-login" onSubmit={login}>
                  <label htmlFor="userName">User name</label>
                  <br></br>
                  <input type="text" name="userName"></input>
                  <br></br>
                  <label htmlFor="userPassword">Password</label>
                  <br></br>
                  <input id="userpassword" type="password" name="userPassword"></input>
                  <br></br>

                  <input type="submit" value="Log in" className="register-login"></input>
                </form>
                <span className="login-status">{loginStatus}</span>
              </div>
            </>
          }
        ></Route>
        <Route
          path="/register"
          element={
            <>
              <div>Register to the system. To register, you need to have a single-use invitation code.</div>
              <form method="post" action="user-register" onSubmit={register}>
                <label htmlFor="userName">
                  User name <b>(Cannot be changed!)</b>
                </label>
                <br></br>
                <input type="text" name="userName"></input>
                <br></br>
                <label htmlFor="userPassword">
                  Password <b>(Cannot be reset!)</b>
                </label>
                <br></br>
                <input type="password" name="userPassword"></input>
                <br></br>
                <label htmlFor="userConfirmPassword">Confirm password</label>
                <br></br>
                <input type="password" name="userConfirmPassword"></input>
                <br></br>
                <label htmlFor="userEmail">Email address</label>
                <br></br>
                <input type="text" name="userEmail"></input>
                <br></br>
                <label htmlFor="userPassword">
                  Invitation code (To get an invitation code, get in touch with Mucube via Discord) )
                </label>
                <br></br>
                <input id="inviteCode" type="text" name="inviteCode"></input>
                <br></br>
                <input type="submit" value="Register" className="register-login"></input>
                <div className="login-alert-message">{alertMessage}</div>
              </form>
            </>
          }
        ></Route>
      </Routes>
    </div>
  );
}
